<div class="group-name-row" (click)="selectLayerGroupClicked(groupElement.id)">
    <div #groupElement [attr.id]="'layer-list-group-' + groupInfo.id">
        {{ groupInfo.name }}
    </div>
    <div class="show-layers-buttons">
        <!-- <cds-button-inline
            (click)="
                !!(groupInfo.id !== undefined && showShowAllButton) && showAllLayersClicked($event)
            "
            [ngClass]="{
                active: groupInfo.id !== undefined && showShowAllButton,
                inactive: !(groupInfo.id !== undefined && showShowAllButton)
            }"
            ><cds-icon shape="eye"></cds-icon
        ></cds-button-inline> -->
        <!-- <cds-button-inline
            (click)="hideAllLayersClicked($event)"
            [ngClass]="{
                active: groupInfo.id !== undefined && showHideAllButton,
                inactive: !(groupInfo.id !== undefined && showHideAllButton)
            }"
            ><cds-icon shape="eye-hide"></cds-icon
        ></cds-button-inline> -->
        <ng-container *ngIf="groupInfo.id !== undefined && showHideAllButton">
            <cds-button-inline (click)="hideAllLayersClicked($event)">Hide all</cds-button-inline>
        </ng-container>
    </div>
</div>
